export type Maybe<T> = T | null | undefined;

export function toValues<T extends { value: string }>(arr: Maybe<Array<string | T>>): string[] {
  return (arr ?? []).map((x) => (typeof x === 'string' ? x : x?.value)).filter(Boolean) as string[];
}

export function arraysEqual(a: Maybe<string[]>, b: string[]) {
  if (!a && b.length === 0) {
    return true;
  }
  if (!a || a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}
